export type FirstLevelProgressCard = {
  fsrsCard: { lastReview: string | null } | null;
  manuallyMasteredAt: string | null;
  skippedAt: string | null;
  startedStudyingAt: string | null;
  userGraphemeMeaningCard: { grapheme: string } | null;
  userGraphemePronunciationCard: { grapheme: string } | null;
};

/** Require the whole first level, then a review of every enabled enrolled card after that level. */
export function hasCompletedFirstLevelAndReviews({
  cards,
  characters,
  pinyinEnabled,
}: {
  cards: readonly FirstLevelProgressCard[];
  characters: readonly string[];
  pinyinEnabled: boolean;
}): boolean {
  if (characters.length === 0) {
    return false;
  }
  let completedAt = 0;
  for (const grapheme of characters) {
    const card = cards.find((row) => row.userGraphemeMeaningCard?.grapheme === grapheme);
    const learnedAt = card?.startedStudyingAt ?? card?.manuallyMasteredAt ?? card?.skippedAt;
    if (!learnedAt) {
      return false;
    }
    completedAt = Math.max(completedAt, Date.parse(learnedAt));
  }
  const reviews = cards.filter((card) => {
    const grapheme =
      card.userGraphemeMeaningCard?.grapheme ??
      (pinyinEnabled ? card.userGraphemePronunciationCard?.grapheme : undefined);
    return (
      grapheme !== undefined &&
      characters.includes(grapheme) &&
      card.startedStudyingAt !== null &&
      card.manuallyMasteredAt === null &&
      card.skippedAt === null
    );
  });
  return (
    reviews.length > 0 &&
    reviews.every(
      (card) =>
        card.fsrsCard?.lastReview != null && Date.parse(card.fsrsCard.lastReview) > completedAt,
    )
  );
}
